/**
 * ChatInnerWithHistory Component
 * Layout for chat with history sidebar enabled
 * Matches online-community's ChatInnerWithHistory structure
 * Footer is positioned outside the chat-session wrapper
 */

import React from 'react';

import { ChatInner } from '../../../Chat/Chat';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import {
  ocRenderAdditionalActions,
  ocRenderAdditionalMessageUI,
  ocRenderMessage,
} from '../../rendering/ocMessageRendering';
import OcTranscriptFooter from '../AskHuman/OcTranscriptFooter';
import ChatHistory from '../ChatHistory/ChatHistory';
import { OcChatFooter } from '../Footer/OcChatFooter';
import OCAILoadingMessage from '../Loading/OCAILoadingMessage';
import {
  ChatInnerWrapper,
  ChatSessionWrapper,
  ChatWithHistoryContainer,
} from './ChatInnerWithHistory.styled';

export interface ChatInnerWithHistoryProps {
  isNarrow?: boolean;
}

/**
 * ChatInnerWithHistory
 * Creates a layout with:
 * - History sidebar on the left
 * - Chat content in the middle (with transcript footer)
 * - Footer with disclaimer at the bottom (outside chat session)
 */
const ChatInnerWithHistory: React.FC<ChatInnerWithHistoryProps> = ({
  isNarrow = false,
}) => {
  const {
    assistantName,
    avatarUrl,
    inputPlaceholder,
    renderMessage,
    renderAdditionalMessageUI,
    renderAdditionalActions,
  } = useOcFabWidgetOptions();

  return (
    <ChatWithHistoryContainer>
      <ChatSessionWrapper>
        <ChatHistory />
        <ChatInnerWrapper>
          <ChatInner
            loadingMessage={<OCAILoadingMessage />}
            transcriptFooter={<OcTranscriptFooter />}
            inputPlaceholder={inputPlaceholder}
            assistantName={assistantName}
            avatarUrl={avatarUrl}
            renderMessage={renderMessage ?? ocRenderMessage}
            renderAdditionalMessageUI={renderAdditionalMessageUI ?? ocRenderAdditionalMessageUI}
            renderAdditionalActions={renderAdditionalActions ?? ocRenderAdditionalActions}
            resetButton={null}
          />
        </ChatInnerWrapper>
      </ChatSessionWrapper>
      <OcChatFooter isNarrow={isNarrow} />
    </ChatWithHistoryContainer>
  );
};

export default ChatInnerWithHistory;